import { NextPage } from 'next';
import React from 'react';
import { Item } from '../../@types/color';
import Gradual from './Gradual';
import Background from './Background';
import Plate from './Plate';

type Props = {
    item: Item
    imgUrl: string | string[]
    max?:boolean
};

const Index: NextPage<Props> = ({ item, imgUrl, max}) => {
    return (
        <>
            {item.type == 1 && <Plate imgUrl={imgUrl} max={max} item={item} />}
            {item.type == 2 && <Gradual imgUrl={imgUrl} max={max} item={item} />}
            {item.type == 3 && <Background imgUrl={imgUrl} item={item} />}
        </>
    )

}

Index.defaultProps = {
    max: false
}

export default Index